var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useImg)?_c('img',{class:['icon', _vm.square ? 'square' : ''],attrs:{"src":_vm.imgUrl,"title":_vm.title},on:{"error":function($event){_vm.imgError = true},"click":_vm.clickFn}}):_c('div',{class:['icon', _vm.square ? 'square' : ''],attrs:{"title":_vm.title},on:{"click":_vm.clickFn}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }